<div class="pdf-line-preview" [class.vertical]="orientation === 'vertical'">
  <div class="line"
       [style.borderColor]="color"
       [style.borderTopStyle]="orientation === 'horizontal' ? lineStyle : null"
       [style.borderTopWidth.px]="orientation === 'horizontal' ? thickness : null"
       [style.borderLeftStyle]="orientation === 'vertical' ? lineStyle : null"
       [style.borderLeftWidth.px]="orientation === 'vertical' ? thickness : null">
  </div>
</div>
